export default __webpack_public_path__ + "static/media/bs3.2.52f99b82.png";